module.exports = __webpack_public_path__ + "img/commandpost_stopped.dbc504b1.svg";